
  import ipxRuntime$c5bYuDBMFn7pLf3NiYFFTgAhjpBXVLzp5UXALzaMXO0 from '/app/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 1024,
    "lg": 1270,
    "xl": 1432,
    "2xl": 1680,
    "xs": 393,
    "3xl": 1910,
    "4xl": 2560
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "gamania.com",
    "www.gamania.com",
    "staging.gamania.com",
    "gamania-official-website.salute.gallery",
    "gamania-official-website.s3.ap-southeast-1.amazonaws.com",
    "127.0.0.1:20000"
  ],
  "alias": {},
  "densities": [
    1,
    2,
    1,
    2
  ],
  "format": [
    "avif",
    "webp",
    "webp"
  ],
  "quality": 80
},
    /** @type {"ipx"} */
    provider: "ipx",
    providers: {
        ['ipx']: { setup: ipxRuntime$c5bYuDBMFn7pLf3NiYFFTgAhjpBXVLzp5UXALzaMXO0, defaults: {} }
    }
  }
